export const DEFAULT_MY_FAVORITES_URL = '/my-account/favorites'
